module.exports = __webpack_public_path__ + "img/dz.d74189dc.jpg";